<template>
  <div class="container">
    <div class="row justify-center">
      <div class="col-md-3">
        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <a class="nav-link" :class="{active: mode === 'focused'}"
             @click="setMode('focused')"
             href="#focused-edit" data-toggle="pill">Focused Mode</a>
          <a class="nav-link" :class="{ active: mode === 'free'}"
             @click="setMode('free')"
             href="#free-edit" data-toggle="pill">Free Mode</a>
        </div>
      </div>
      <div class="col-md-9">
        <div v-show="mode === 'focused'" id="focused-edit">
          <focused-send-to-details :view="view" />
        </div>
        <div v-show="mode === 'free'" id="free-edit">
          <free-send-to-details :view="view" />
        </div>
      </div>
    </div>
    <modal-overlay
      :active="errorModalActive"
      confirm="Refresh Page"
      @cancel="errorModalActive = false"
      @confirm="refreshPage()"
    >
      <template v-slot:header>
        <span class="text-danger">Error!</span>
      </template>
      <template v-slot:default>
        <div>{{$store.state.sendToDetails.error.message}}</div>
        <br>
        <pre>{{$store.state.sendToDetails.error.code}}</pre>
      </template>
    </modal-overlay>
  </div>
</template>
<script>
  import {isValidJSON} from '../../lib/helpers'

  export default{
    props:{
      sendToTypes: {type: Array, required: true},
      submissionUrl: {type: String, required: true},
      cancelUrl: {type: String, required: true},
      searchUrl: {type: String, required: true},
      sendToConfigUrl: {type: String, required: true},
      generateFtpAccountUrl : {type: String, required: true},
      leadTableColumns: { type: Array, required: true },
      sendToDetails: {type: Object, default(){ return {} }},
      view: {type: String}
    },
    data(){
      return {
        mode: 'focused',
        errorModalActive: false,
        configFetched: false
      }
    },
    created(){
      
      //Set constant values
      this.$store.commit('sendToDetails/SET_URLS', {
        submissionUrl: this.submissionUrl,
        cancelUrl : this.cancelUrl,
        searchUrl : this.searchUrl,
        sendToConfigUrl : this.sendToConfigUrl,
        generateFtpAccountUrl: this.generateFtpAccountUrl
      })
      this.$store.commit('sendToDetails/SET_LEAD_TABLE_COLUMNS', this.leadTableColumns)
      this.$store.commit('sendToDetails/SET_SEND_TO_TYPES', this.sendToTypes)
      
      //Set send to details if already exist
      const stdKeys = Object.keys(this.sendToDetails);
      if(stdKeys.length){
        stdKeys.forEach((key)=>{
          this.$store.commit('sendToDetails/UPDATE_CURRENT_SEND_TO_DETAILS_FOR_KEY', {
            key: key,
            value: this.sendToDetails[key]
          })
        })
        
        //Set JSON info if already exists
        if( isValidJSON(this.sendToDetails.json_info) ){
          const jsonInfo = JSON.parse(this.sendToDetails.json_info);
          Object.keys(jsonInfo).forEach((key)=>{
            this.$store.commit('sendToDetails/UPDATE_CURRENT_JSON_DATA_FOR_KEY', {
              key: key,
              value: jsonInfo[key]
            })
          })
        }
      }
      
      //Set recruiting id from the url
      const urlParams = new URLSearchParams(window.location.search);
      if(urlParams.has('recruiting_id')) {
        this.$store.commit('sendToDetails/UPDATE_CURRENT_SEND_TO_DETAILS_FOR_KEY',
          {key: 'company_ID', value: urlParams.get('recruiting_id')}
        )
      }
      
      //Set the proper mode
      if(urlParams.has('mode')){
        this.mode = urlParams.get('mode')
      }
    },
    mounted(){
      if(window.location.hash && document.querySelector(window.location.hash)){
        setTimeout(()=>{ document.querySelector(window.location.hash).scrollIntoView() }, 1000)
        
      }
    },
    methods:{
      refreshPage(){
        window.location.reload()
      },
      setMode(mode){
        this.mode = mode;
      }
    },
    watch:{
      '$store.state.sendToDetails.error.error' : {
        handler(err){
          if(err) this.errorModalActive = true;
        }
      },
      '$store.state.sendToDetails.companyQuery':{
        handler(){
          this.$store.dispatch('sendToDetails/searchCompanies')
        }
      },
      '$store.state.sendToDetails.current.sendToDetails.send_to_type':{
        handler(){
          this.$store.dispatch('sendToDetails/setCurrentConfig', !(this.view === 'edit' && !this.configFetched))
          this.configFetched = true
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .nav-pills{
    a.active{
      background:#82bc00 !important;
    }
  }
</style>
